import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withFetch,
  HttpClient,
} from '@angular/common/http';
import {
  BrowserAnimationsModule,
  provideNoopAnimations,
} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { SubscriptionKeyInterceptor } from './app/services/subscription-key.interceptor';
import { ConnectivityInterceptor } from './app/services/http-services/http-interepter';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LmsService } from './app/services/lms.service';
import { TranslateHttpLoader } from './app/translate.loader';
import { LoadingInterceptor } from './app/services/interceptors/loading.interceptor';

export function createTranslateLoader(lmsService: LmsService, http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(lmsService, http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    importProvidersFrom(
      BrowserAnimationsModule,
      ToastrModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [LmsService, HttpClient]
        }
      }),
      BrowserModule
    ),

    provideNoopAnimations(),

    provideHttpClient(withInterceptorsFromDi(), withFetch()),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubscriptionKeyInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConnectivityInterceptor,
      multi: true,
    }
  ],
};